module.exports = __webpack_public_path__ + "img/sensis-logo.b79a5d6b.svg";